// let sportUrl = process.env.NODE_ENV === 'production' ?
//  'http://sc.ttmna.com' + '/api/v1' : '/sportapi'
let sportUrl = "/sportapi";
let sportUrl1 = "/sportapi1";
let sportUrl3 = "/sportapi3";
// window.newsports 测试体育api地址http://sportsapi.zbitcloud.com/api/v1
// 正式地址https://sportsapi.ycdnedu.com/api/v1

// 5.14 替换体育接口  https://sportsapi.ycdnedu.com =》http://sc.ttmna.com/api

export default {
  getMatchAllList: sportUrl + "/basketball/getMatchAllList",
  footballList: sportUrl + "/football/getMatchAllList",
  basketballPlayingList: sportUrl1 + "/basketball/getMatchPlayingList",
  footballPlayingList: sportUrl1 + "/football/getMatchPlayingList",
  basketballListByDate: sportUrl1 + "/basketball/getMatchListByDate",
  footballListByDate: sportUrl1 + "/football/getMatchListByDate",
  liveSportsList: sportUrl + "/live/getRandomList",
  liveSportsPcList: sportUrl + "/live/getPcLiveList",
  sportgetHomeData: sportUrl1 + "/basketball/getSlideEvents",
  clickStatistics: sportUrl + "/statistics/click",
  [sportUrl + "/statistics/click"]: { specil: true },
  [sportUrl + "/live/getPcLiveList"]: { specil: true },
  NewfootballAllList: sportUrl3 + "/football/getMatchAllList",
  NewfootballPlayingList: sportUrl3 + "/football/getMatchPlayingList",
  NewfootballHotList: sportUrl3 + "/football/getMatchListByHot",
  NewfootballDateList: sportUrl3 + "/football/getMatchListByDate",
  NewfootballMatchSum: sportUrl3 + "/football/getMatchSum",
  NewbasketballAllList: sportUrl3 + "/basketball/getMatchAllList",
  NewbasketballPlayingList: sportUrl3 + "/basketball/getMatchPlayingList",
  NewbasketballHotList: sportUrl3 + "/basketball/getMatchListByHot",
  NewbasketballDateList: sportUrl3 + "/basketball/getMatchListByDate",
  NewbasketballMatchSum: sportUrl3 + "/basketball/getMatchSum",
};



// WEBPACK FOOTER //
// ./src/http/api.js